export default __webpack_public_path__ + "static/media/45304.d3014be2.jpg";